import { createGlobalStyle } from 'styled-components'

import COLOR from '@/components/cell/designTokens/color'

import theme from './'

const GlobalStyle = createGlobalStyle`

    *::selection {
        background-color: ${COLOR.lightYellow};
    }

    :root {
        --unit: 1px;
        font-size: calc(var(--unit) * 16);
    }

    html {
        font-family: system-ui;
    }

    html, body {
        height: 100%;
        width: 100%;
        margin: 0px;
        padding: 0px;
    }

    body {
        overscroll-behavior-y: none;
        /* background-color: #dbdbdb; */
        /* overflow: hidden; */
    }

    .root,
    .root > div {
        height: 100%;
        width: 100%;
    }
    /* 언어별 표시 유무용 */
    *[class*="only-lang"] {
        display: none !important;
    }

    /* 한국어 일때만 보이기 */
    :lang(ko) *.only-lang-ko {
        display: inherit !important;
    }

    /* 일본어 일때만 보이기 */
    :lang(ja) *.only-lang-ja {
        display: inherit !important;
    }

    @media screen and (max-width: ${theme.width.mobile.default}px) {
        :root {
            --unit: calc(100vw / ${theme.width.mobile.default});
        }
    }

    a {
        text-decoration: none;
        color: inherit;
        &:hover {
            text-decoration: none;
        }
    }
    
    button, input, textarea, select {
      font-family: inherit;
      font-size: inherit; 
    }
`

export default GlobalStyle
